import { Lambda } from "../../common/services/http-service"
import { LambdaAdmin } from "../../common/services/http-service"

const useUsers = () => {
    const existPhone = async (phone) => {
        try {
            return await Lambda({ resource: `users/exists?phone_number=${phone}`, method: "get", isPublic: false });   
        } catch (error) {
            console.log("[Error on existPhone]:", error);
            return { exists: true, msg: "Error al revisar si se encuentra en uso." }
        }
    };

    const existEmail = async(email) => {
        try {
            return await Lambda({ resource: `users/exists?email=${email}`, method: "get", isPublic: false });
        } catch (error) {
            console.log("[Error on existEmail]:", error);
            return { exists: true, msg: "Error al revisar si se encuentra en uso." }
        }
        
    };

    const sendRecoveryCode = async (username, option, phone, email) => {
        try {
            let payload = {
                UsuarioLogin: username,
                Opcion: option,
                phone_number: phone,
                email: email
            };
        
            return await Lambda({ resource: `cognito/credentials/recovery/code`, method: "post", isPublic: true, data: JSON.stringify(payload) });
        } catch (error) {
            console.log("[Error on seendRecoveryCode]:", error);
            if (error?.response) {
                return error?.response.data;
            }
            return { error: "Error al enviar código." };
        }
    };

    const verifyRecoveryCode = async (username, option, code, answer) => {
        try {
            let payload = {
                UsuarioLogin: username,
                Opcion: option,
                CodigoRecupera: code,
                UsuarioSecreta: answer
            };
        
            return await Lambda({ resource: `cognito/credentials/recovery/verify`, method: "post", isPublic: true, data: JSON.stringify(payload) });   
        } catch (error) {
            console.log("[Error on verifyRecoveryCode]:", error);
            if (error?.response) {
                return error?.response.data;
            }
            return { error: "Error al verificar código." };
        }
    };

    const saveDataAccount = async (username, phone_number, email, question, answer, TicketID) => {
        try {
            let payload = {
                username,
                phone_number,
                email,
                question,
                answer,
                TicketID
            };
            let credential = payload.phone_number ? "phone" : "email";
        
            return await LambdaAdmin({ resource: `soporte/usuarios?credential=${credential}`, method: "PUT", data: payload });   
        } catch (error) {
            console.log("[Error on saveDataAccount]:", error);
            if (error?.response) {
                return error?.response.data;
            }
            return { error: "Error al guardar nuevo dato." };
        }
    };


    const enviaEmailRestablecer = async (UsuarioID, TicketID, To, Molde) => {
        try {
            let payload = {
                UsuarioID: UsuarioID,
                TicketID: TicketID,
                To: To,
                Molde: Molde
            };
            return await LambdaAdmin({ resource: `soporte/usuarios/password/email`, method: "POST",  data: payload });
        } catch (error) {
            console.log("[Error on enviaEmailRestablecer]:", error);
            if (error?.response) {
                return { extioso: false, data: error?.response.data }
            }
            return { extioso: false,  error: "Error al Restablecer." }
        }
    };

    const enviaSMSRestablecer = async (UsuarioID, TicketID, To, CURP) => {
        try {
            let payload = {
                UsuarioID: UsuarioID,
                TicketID: TicketID,
                To: To,
                CURP:CURP
            }; 
            return await LambdaAdmin({ resource: `soporte/usuarios/password/sms`, method: "POST",  data: payload });
        } catch (error) {
            console.log("[Error on enviaSMSRestablecer]:", error);
            if (error?.response) {
                return { extioso: false, data: error?.response.data }
            }
            return { extioso: false,  error: "Error al Restablecer." }
        }
    };

    return {
        existPhone,
        existEmail,
        sendRecoveryCode,
        verifyRecoveryCode,
        saveDataAccount,
        enviaEmailRestablecer,
        enviaSMSRestablecer
    };
};

export default useUsers;